<template>
    <div id="userdetail-page" class="mb-5">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">{{$t('dashboard')}}</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/department">{{$t('department')}}</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <form v-on:submit.prevent="doSubmit" class="mt-2">
              <b-row>
                <b-col md="5">
                  <label class="labels">{{$t('name')}} *</label>
                  <div class="form-group" v-bind:class="errors.has('name') ? 'has-error':''">
                    <input type="text" class="form-control" v-bind:class="errors.has('name') ? 'is-invalid':''" v-validate="'required'" data-vv-as="name" name="name" v-model="model.name" :placeholder="$t('name')" />
                    <p v-if="errors.has('name') !== null"></p>
                  </div>
                </b-col>
                <b-col md="2">
                </b-col>
                <b-col md="5">
                  <label class="labels">{{$t('company')}} *</label>
                  <div class="form-group" v-bind:class="errors.has('company') ? 'has-error':''">
                    <b-form-select name="company" v-model="model.company" v-validate="modelValidations.company" v-bind:class="errors.has('company') ? 'is-invalid':''" :error="errors.first('company')" :options="companyList" placeholder="Company">
                    </b-form-select>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <label class="labels">email *</label>
                  <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                    <input type="email" class="form-control" v-bind:class="errors.has('email') ? 'is-invalid':''" v-validate="'required'" data-vv-as="email" name="email" v-model="model.email" placeholder="Ex: myname@example.com" />
                    <p v-if="errors.has('email') !== null"></p>
                  </div>
                </b-col>
                <b-col md="2">
                </b-col>
                <b-col md="5">
                  <label class="labels">{{$t('branch')}} *</label>
                  <b-form-select class="form-group" name="branch" v-model="model.branch" v-validate="modelValidations.branch" v-bind:class="errors.has('branch') ? 'is-invalid':''" :error="errors.first('branch')" :options="branchList">
                  </b-form-select>
                </b-col>
                <b-button variant="light" style="margin-left:-73px!important; margin-top:17px!important; padding-bottom:6px!important;" disabled><font-awesome-icon icon="spinner" spin v-if="isLoadingBranch" />
                </b-button>
              </b-row>
              <!-- <b-row>
                <b-col md="5">
                  <label class="labels">telephone *</label>
                  <div class="form-group" v-bind:class="errors.has('phone') ? 'has-error':''">
                    <input type="number" class="form-control" v-bind:class="errors.has('phone') ? 'is-invalid':''" v-validate="'required'" data-vv-as="phone" name="phone" v-model="model.phone" placeholder="Telephone" />
                    <p v-if="errors.has('phone') !== null"> </p>
                  </div>
                </b-col>
                <b-col md="1">
                  <div class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error':''">
                    <input type="number" class="form-control label-ext" data-vv-as="extPhone" name="extPhone" v-model="model.extPhone" placeholder="Ext" />
                  </div>
                </b-col>
                <b-col md="1">
                </b-col>
                <b-col md="5">
                  <label class="labels">fax *</label>
                  <div class="form-group" v-bind:class="errors.has('fax') ? 'has-error':''">
                    <input type="number" class="form-control" v-bind:class="errors.has('fax') ? 'is-invalid':''" v-validate="'required'" data-vv-as="fax" name="fax" v-model="model.fax" placeholder="Fax" />
                  </div>
                </b-col>
              </b-row> -->
              <div class="mt-4">
                <b-button class="mr-2" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
                <b-button :variant="$route.params.id !== undefined ? 'warning' : 'primary'" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{$route.params.id !== undefined ? 'Update' : $t('save')}} </b-button>
              </div>
            </form>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'department-form',
        data () {
            return {
                isLoading: false,
                isLoadingBranch: false,
                apiUrl: {
                    department: window.AppConfig.apiUrl + 'department',
                },
                model: {
                  name: '',
                  branch: '',
                  company: '',
                  phone: '',
                  extPhone: '',
                  fax: '',
                  email: '',
                },
                modelValidations: {
                  company: {
                    required: true
                  },
                  branch: {
                    required: true
                  }
                },
                branchList: [
                  {
                    value: "",
                    text: this.$root.$t('selectBranch')
                  }
                ],
                companyList: [{
                  value: "",
                  text: this.$root.$t("selectCompany")
                }],
            }
        },
        watch: {
          'model.company' (value) {
              this.getDetailBranch(value)
          }
        },
        mounted () {
            this.initData()
            this.getDetailCompany()
        },
        methods: {
            initData() {
              if (this.$route.params.id !== undefined){
                this.getDetail()
              }
            },
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.department + '/' + this.$route.params.id).then(response => {
                  this.model.name = response.data.name !== null ? response.data.name : '-'
                  this.model.company = response.data.company !== null ? response.data.company.uuid : '-'
                  this.model.branch = response.data.branch !== null ? response.data.branch.uuid : '-'
                  this.model.phone = response.data.phone !== null ? response.data.phone : '-'
                  this.model.extPhone = response.data.extPhone !== null ? response.data.extPhone : '-'
                  this.model.fax = response.data.fax !== null ? response.data.fax : '-'
                  this.model.email = response.data.email !== null ? response.data.email : '-'
                })
                .catch(error => {
                    this.isLoading = false
                    this.$store.dispatch('notification/error', error)
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('DD MMM YYYY HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'success'
                    break
                case 1:
                    return 'info'
                    break
                }
            },
            doSubmit () {
              this.$validator.validateAll().then(res => {
                if (res) {
                  if (this.$route.params.id !== undefined) {
                    this.$http.patch(this.apiUrl.department + '/' + this.$route.params.id, this.model).then(response => {
                      this.$store.dispatch('notification/success', this.$root.$t('companyNotifUpdate'))
                      window.location.href = document.URL.replace('/edit', '')
                    }).catch(error => {
                      this.$store.dispatch('notification/error', error)
                    })
                  } else {
                    this.$http.post(this.apiUrl.department, this.model).then(response => {
                      this.$store.dispatch('notification/success', this.$root.$t('companyNotif'))
                      window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
                    }).catch(error => {
                      this.$store.dispatch('notification/error', error)
                    })
                  }
                } else {
                  swal("", "Please fill the required fields!", "info", {
                    buttons: false,
                    timer: 2000
                  });
                }
              })
            },
            getDetailBranch (companyUuid = null) {
              this.isLoadingBranch = true
              this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
                this.branchList = []
                this.isLoadingBranch = false
                response.data._embedded.branch.forEach(data => {
                    this.branchList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              }).catch(error => {
                window.consoleLog(error)
                this.isLoadingBranch = false
              })
            },
            getDetailCompany () {
              this.$http.get(window.AppConfig.apiUrl + 'company?limit=100').then(response => {
                response.data._embedded.company.forEach(data => {
                    this.companyList.push({
                      value: data.uuid,
                      text: data.name
                    })
                })
              })
            },
        }
    }
</script>